<template>
  <div class="xcard">
    <h3 class="text-center" style="margin-top:0"> Dashboard de Inscripciones por Programa </h3>
    <p class="text-center text-primary"> <small>Inscripciones por programa de cada sede.</small> </p>

     

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> Seleccione la Sede: </div>
            <Sedes :model="sede" :tosedes="sedes" :default="sede.idsede"/>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> Seleccione una Gestion: </div>
            <Gestiones :model="gestion" :default="gestion.gestion"/>
          </div>
        </div>
      </div>
    </div>

    <button class="btn btn-sm btn-link" @click="cambiar()"> <span class="glyphicon glyphicon-signal"></span> Cambiar Grafico</button>

    <div class="row">
      <div class="col-sm-12">
        <canvas id="planet-chart"></canvas>
      </div>

      <div class="col-sm-12">
        <p v-if="datos.length>0" class="text-center text-success">Inscripciones:</p>
        <div v-bind:key="ind" v-for="(i,ind) in datos" style="font-size:12px;margin-bottom:12px">
          <p class="text-primary" style="margin-bottom:0"> <b>{{i.nombre}}:</b> </p>
          <b style="margin-left:28px">Ins:</b> <span>{{ i.dip }} </span> 
        </div>
      </div>
    </div>

    <Alertas ref="alertar" />

    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import {parseJsonError} from '@/components/Utils.js'
import Sedes from '@/components/ASedes'
import Alertas from '@/components/AAlertas.vue'
import Gestiones from '@/components/AGestiones'
import gql from 'graphql-tag'
import Chart from 'chart.js';
export default {
  data(){
    return{
      sede: {idsede:null},
      gestion: {gestion:{gestion:null}},
      semaforo: {idsemaforo:{}},
      sedes:{sedes:[]},
      semaforos: [],
      datos: [],
      labeles: [],
      labeles2: [],
      diplomados: [],
      especialidades: [],
      maestrias: [],
      char: null,

      planetChartData: {
        type: 'bar',
        data: {
          labels: [],
          datasets: [
            {
              label: 'Inscritos de cada programa',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 3
            },
            /*{
              label: 'Especialidades',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 3
            },
            {
              label: 'Maestrias',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 3
            }*/
          ]
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                padding: 25,
              }
            }]
          }
        }
      }


    }
  },
  components:{ Sedes,Gestiones,Alertas },
  watch:{
    'gestion.gestion':function(){
      this.listener();
    },
    'sede.idsede':function(){
      this.listener();
    },
  },
  methods:{
    listener(){
      if( this.sede.idsede == null || this.gestion.gestion == null ) return;
      this.labeles = [];
      this.labeles2 = [];
      var sql = gql`query{ getProgramas(idsede:${this.sede.idsede.id},gestion:${this.gestion.gestion.gestion}){ postgrado{nombre,categoria{nombre}},inscripciones{id} } }`;
      //window.console.log( 'kkkkkkkkkkk',sql);
      this.getInscripciones( sql );
    },
    cambiar(){
      if( this.planetChartData.type == "bar" ) this.planetChartData.type = "line";
      else this.planetChartData.type = "bar";
      this.createChart( 'planet-chart',this.planetChartData )
    },

    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      if( this.char ) this.char.reset();

      this.char = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
      this.$refs.alertar.reset();
    },
    async getInscripciones( sql ){
      this.$refs.alertar.cargando();
      await this.$apollo.query({
        query: sql,
        }).then((data) => {
          var lista = data.data.getProgramas;
          this.datos = [];
          this.diplomados = [];
          var vue = this;
          var cd = []; var bd = [];
          
          lista.forEach(function(e,i){
            var d = 0;
            var cat = '';
            if( e.postgrado.categoria ) cat = e.postgrado.categoria.nombre;
            var n = e.postgrado.nombre;
            /*n = n.replace(' ','_').toLowerCase();
            n = n.replace(' ','_');*/
            n = n.replace('í','i')
            n = cat +" "+n;
            cd.push( '#1976d2' );
            bd.push( '#004ba0' );
            // var nn = cat +" "+e.postgrado.nombre;
            var nn = e.postgrado.nombre;
            if( nn.length > 22 ) nn = nn.substring(0,22)+"...";

            vue.labeles.push( nn );
            vue.labeles2.push( n );

            d += e.inscripciones.length;
            vue.datos.push( {sede:vue.labeles[i],nombre:vue.labeles2[i],dip:d} );
            vue.diplomados.push(d);

          });


          /*window.console.log( vue.datos );
          window.console.log( vue.diplomados );*/

          vue.planetChartData.data.labels = vue.labeles;
          vue.planetChartData.data.datasets[0].data = vue.diplomados;
          vue.planetChartData.data.datasets[0].backgroundColor = cd;
          vue.planetChartData.data.datasets[0].borderColor = bd;
          /*vue.planetChartData.data.datasets[1].data = vue.especialidades;
          vue.planetChartData.data.datasets[1].backgroundColor = ce;
          vue.planetChartData.data.datasets[1].borderColor = be;
          vue.planetChartData.data.datasets[2].data = vue.maestrias;
          vue.planetChartData.data.datasets[2].backgroundColor = cm;
          vue.planetChartData.data.datasets[2].borderColor = bm;*/
          vue.createChart( 'planet-chart',vue.planetChartData )
          
        }).catch((error) => {
          window.console.error(error)
          this.$notify( parseJsonError( error,'getInscripcionesByUser' ) )
        })
    },
  },
  mounted(){
    this.gestion.gestion.gestion = new Date().getFullYear();
    if( this.$store.state.CARGO ){
      this.sede.idsede = {id:this.$store.state.CARGO.sede.id,nombre:this.$store.state.CARGO.sede.nombre}
    }
    this.$refs.alertar.cargando();
    //window.console.log( "jjjjjjjjjj  jj j j j j ",this.$store.state.CARGO )
    //this.createChart( 'planet-chart',this.planetChartData )
  }
}
</script>